// extracted by mini-css-extract-plugin
export default {"name":"employeeWithDetailsPopover_name__KhI45","name__link":"employeeWithDetailsPopover_name__link__EEa45","popoverbutton":"employeeWithDetailsPopover_popoverbutton__rjQbX"};